import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';
import { MysqlService } from './../../../../services/mysql.service';
import { SubjectNote } from './../../../../api/subjectNote';
import { SubjectBilling } from './../../../../api/subjectBilling';
import {DemoService} from '../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { GlobalFunctionsService } from './../../../../services/global-functions.service';

@Component({
  selector: 'app-subject-status-change',
  templateUrl: './subject-status-change.component.html',
  styleUrls: ['./subject-status-change.component.css']
})
export class SubjectStatusChangeComponent implements OnInit {

  @Input() subject_id: number;
  @Input() job_id: number;
  @Input() file_number: number;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  subjects: any;
  job_status_run: any;
  job_status_details: any;
  current_job_status_name: any;
  job_status_details_selected: any;
  original_job_status: any;

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    public gfunc: GlobalFunctionsService
  ) {
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUsername = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
    this.brand_id = this.sessionBrandId;
    // this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();
  }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}


getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.subjects = data;
      const res = data[0];
     // this.getSubjectNotes(res.subject_id);

     // Need to loop up status
     this.getJobStatusDetails(res.job_status);
    this.getJobStatusDetailsSelected(res.job_status); // load selected first

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => this.job_status_run = res,
      err => console.error(err.status)
    );
}



getJobStatusDetails(job_status_name){
  this._demoService.getJobStatusDetails(job_status_name)
  .subscribe(
    res => {this.job_status_details = res;
      const data = res[0];
      this.original_job_status = data.job_status_name; // set so that we can hide the update button if the job has already been closed.
    
    },
    err => console.error(err.status)
  );

}


getJobStatusDetailsSelected(job_status_name){
  this._demoService.getJobStatusDetails(job_status_name)
  .subscribe(
    res => this.job_status_details_selected = res,
    err => console.error(err.status)
  );

}

updateSubjectStatus(model){
  model.job_id = this.job_id;
  this._demoService.updateSubjectStatus(model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    // this.toastr.success('Subject Status Updated');
    this.gfunc.insertLog_UpdateSubjectStatus(model);
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
    },
    error => {
     // console.error('Error saving Event!');
      // this.toastr.error('Error Changing Status of Subject');
     return console.log(error);
    }
   // err => console.error(err),
   // () => console.log('done updates')
);}




}
